import React from "react";

import getPassword from "../../../../services/passwordGenerator";
import checkEmail from "../../../../services/checkEmail";
import { _AVATAR_ } from "../../../../config/defaults";

import Server from "../../../../services/Server";

import swal from "sweetalert";

import SubscribersLoaderView from "./SubscribersLoader";

const defaultHeaderFields = [
  { index: "notify", label: "Notificar" },
  { index: "name", label: "Nombre" },
  { index: "email", label: "Correo" },
];

function SubscribersLoader(props) {
  const [subscribers, setSubscribers] = React.useState([]),
    [downloadIndex, setDownloadIndex] = React.useState(0),
    [rawData, setRawData] = React.useState(""),
    [isLoading, setLoadingStatus] = React.useState(false),
    { currentUser = {} } = props,
    { uid, customLogo = false } = currentUser;

  const { subscribersTemplate = [] } = props.event;

  const [Header, setHeader] = React.useState([]);

  React.useEffect(() => {
    const { login_methods = {} } = props.event,
      { code = false, email = false } = login_methods;

    const { subscribersTemplate = [] } = props.event;

    const currentHeader = [...defaultHeaderFields];

    if (email) {
      currentHeader.push({ index: "password", label: "Contraseña" });
    }

    if (code) {
      currentHeader.push({ index: "code", label: "Código de Acceso" });
    }

    subscribersTemplate.forEach((record) => {
      currentHeader.push({ index: record.index, label: record.name });
    });

    setHeader(currentHeader);
  }, [props.event]);

  React.useEffect(() => {
    const arrLines = rawData.split("\n"),
      _arrSubscribers = {},
      arrSubscribers = [];

    const { login_methods = {} } = props.event,
      { code = false, email = false } = login_methods;

    const { subscribersTemplate = [] } = props.event;

    let lineSize = 0,
      _password = "",
      _code = "";

    arrLines.forEach((row, index) => {
      const arrColumns = row.split("\t");
      lineSize = arrColumns.length;

      if (lineSize >= 2) {
        if (checkEmail(arrColumns[1])) {
          if (email) {
            if (typeof arrColumns[2] === "undefined") {
              _password = getPassword(12);
            } else {
              if (
                typeof arrColumns[2] === "string" &&
                arrColumns[2].length > 5
              ) {
                _password = arrColumns[2].replace(/\s/gi, "").trim();
              } else {
                _password = getPassword(12);
              }
            }

            if (code) {
              if (typeof arrColumns[3] === "undefined") {
                _code =
                  getPassword(4, true, "text") + getPassword(4, true, "number");
              } else {
                if (
                  typeof arrColumns[3] === "string" &&
                  arrColumns[3].length > 5
                ) {
                  _code = arrColumns[3]
                    .replace(/[^a-zA-Z0-9@.ñ\-_]+/gi, "")
                    .replace(/\s/gi, "")
                    .trim();
                } else {
                  _code =
                    getPassword(4, true, "text") +
                    getPassword(4, true, "number");
                }
              }
            }
          } else {
            if (code) {
              if (typeof arrColumns[2] === "undefined") {
                _code =
                  getPassword(4, true, "text") + getPassword(4, true, "number");
              } else {
                if (
                  typeof arrColumns[2] === "string" &&
                  arrColumns[2].length > 5
                ) {
                  _code = arrColumns[2]
                    .replace(/[^a-zA-Z0-9@.ñ\-_]+/gi, "")
                    .replace(/\s/gi, "")
                    .trim();
                } else {
                  _code =
                    getPassword(4, true, "text") +
                    getPassword(4, true, "number");
                }
              }
            }
          }

          const _userData = {
            name: arrColumns[0],
            lastname: "",
            email: arrColumns[1],
            photoURL: _AVATAR_,
          };

          let _tidx = 2;

          if (email) {
            _tidx++;
            if (code) {
              _tidx++;
            }
          } else {
            if (code) {
              _tidx++;
            }
          }

          if (email) {
            _userData.password = _password;
          }

          if (code) {
            _userData.code = _code;
          }

          (subscribersTemplate || []).forEach((record) => {
            _userData[record.index] = arrColumns[_tidx] || "";
            _tidx++;
          });

          _arrSubscribers[arrColumns[1]] = _userData;
        }
      }
    });

    for (var obj in _arrSubscribers) {
      arrSubscribers.push(_arrSubscribers[obj]);
    }
    setSubscribers(arrSubscribers);
  }, [rawData, props.event]);

  const sendData = () => {
    setLoadingStatus(true);
    let idx = 0;
    const { login_methods = {} } = props.event,
      {
        code = false,
        email = false,
        facebook = false,
        google = false,
        twitter = false,
      } = login_methods;

    const onlyCode = code && !email && !facebook && !google && !twitter;

    const eventData = {
        id: props.event.id,
        name: props.event.name,
        url: props.event.url,
        startDate: props.event.startDate.format("DD [de] MMM [de] YYYY, HH:mm"),
        gmt: props.event.gmt,
        uid: uid,
        hasCustomBrand: customLogo,
        eventCustomBrand: props.event.customLogo || false,
        onlyCode,
        hasAccessCode: code,
      },
      subscribersSize = subscribers.length,
      inputs = document.querySelectorAll("td input.subscribers-loader-notify");
    const _process = (index, error) => {
        if (index + 1 >= subscribersSize) {
          swal({
            title: "",
            text: "La lista ha sido procesada",
            icon: "success",
            buttons: false,
            dangerMode: false,
          }).then(() => {
            setLoadingStatus(false);
          });
        } else {
          idx++;

          if (downloadIndex !== idx) {
            setDownloadIndex(idx);
          }
          _sendRow(idx);
        }
      },
      _sendRow = (index) => {
        subscribers[index].needNotification = inputs[index].checked;

        Server.createSubscriber(subscribers[index], eventData)
          .then(() => {
            _process(index);
          })
          .catch((err) => {
            console.error(subscribers[index], err);
            const { name, lastname, email } = subscribers[index];
            swal({
              title: "",
              text:
                `Hubo un error con ${name} ${lastname}, con correo ${email}, por favor revisa sus datos e intentalo nuevamente` +
                err.response.data,
              icon: "error",
              buttons: true,
              dangerMode: false,
            }).then(() => {
              _process(index, true);
            });
          });
      };

    _sendRow(0);
  };

  const onCheckAll = ({ check = true }) => {
    const inputs = document.querySelectorAll(
      "td input.subscribers-loader-notify"
    );
    inputs.forEach((_input) => {
      _input.checked = check;
    });
    return true;
  };

  return (
    <SubscribersLoaderView
      props={props}
      header={Header}
      rawData={rawData}
      setRawData={setRawData}
      subscribersTemplate={subscribersTemplate}
      subscribers={subscribers}
      isLoading={isLoading}
      downloadIndex={downloadIndex}
      onCheckAll={onCheckAll}
      sendData={sendData}
    />
  );
}

export default SubscribersLoader;
